import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'usuarioNull'
})
export class UsuarioNullPipe implements PipeTransform {

  transform(value: string): string {

    console.log(value,'pipe');
    if (!value) return value;
    value.replace(' NULL', '').trim();
    value.replace('undefined', '').trim();
    return value
  }

}
